/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { Box, Skeleton } from '@mui/material';

export const SkeletonTabMenu = memo(() => {
  return (
    <Box
      sx={{
        width: '140px',
        minWidth: '140px',
        maxWidth: '140px',
        flexShrink: 0,
        overflow: 'hidden',
        height: '100%',
        backgroundColor: 'background.paper',
        borderRight: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 2,
        alignItems: 'stretch',
      }}
    >
      {[...Array(7)].map((_, index) => (
        <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, width: '100%' }}>
          <Skeleton variant="circular" width={24} height={24} sx={{ alignSelf: 'center' }} />
          <Skeleton variant="text" width="80%" height={20} sx={{ alignSelf: 'center' }} />
        </Box>
      ))}
    </Box>
  );
});
